export default "__VITE_ASSET__ok4J2xUe__"